class FormReceiverManager {
  recipient
  constructor (recipient) {
    this.recipient = recipient
  }

  phoneFuse (area, number) {
    return `${area}` + `${number}`
  }

  getField (defaultValues) {
    const area = this.recipient?.phones?.mobile_phone?.area_code
    const number = this.recipient?.phones?.mobile_phone?.number

    return {
      ...defaultValues,
      initialValues: {
        name: this.recipient?.name,
        email: this.recipient?.email,
        phone: this.phoneFuse(area, number)
      }
    }
  }
}

export default FormReceiverManager
